import { RouterType } from '../helpers/types'
import TasksKanban from '../containers/Lawyer/Task/TasksKanban'
import TaskView from '../containers/Client/Task/TaskView'
import Settings from '../containers/Settings'
import TasksProjectKanban from '../containers/Lawyer/Task/TasksProjectKanban'
import {TestForCors} from "../components/TestForCors";
import {OnBoarding} from "../containers/Client/Onboarding/Main/Onboarding";
import {Offers} from "../containers/Client/Onboarding/OfferList/Offers";
import {OfferView} from "../containers/Client/Onboarding/OfferView/OfferView";
import {Offer} from "../containers/Client/Offer/Offer";
import {LegalRequest} from "../containers/Client/LegalRequest/LegalRequest";
import {TestRoute} from "../containers/TestRoute";
import {DeliverableView} from "../containers/Client/Offer/DeliverableView";
import {Checkout} from "../containers/Settings/Routes/Checkout/Checkout";
import {FinishStep} from "../components/other/EmailHaveBeenSent/FinishStep";
import NotFound from "../containers/NotFound/NotFound";
import {Test} from "../components/other/Test";
import {Report} from "../containers/Client/Report/Report";
import {DocumentsList} from "../containers/Documents/DocumentsList";
import {SearchResults} from "../containers/Other/SearchResults/SearchResults";
import {BusinessGoalView} from "../containers/BusinessGoals/BusinessGoalView/BusinessGoalView";
import {BusinessGoalsVloKanban} from "../containers/BusinessGoals/BusinessGoalsVloKanban/BusinessGoalsVloKanban";
import {UpdateNps} from "../components/other/updatNps/UpdateNps";
import {PaymentPlan} from "../containers/Settings/Routes/PaymentPlan/PaymentPlan";
import {NpsNoAuthRoute} from "../components/other/updatNps/NpsNoAuthRoute";
import {NpsAdmin} from "../components/other/updatNps/NpsAdmin";
import {FollowUpList} from "../containers/FollowUp/FollowUpList/FollowUpList";
import {FollowUpView} from "../containers/FollowUp/FollowUpView/FollowUpView";
import {FollowUpNewCalls} from "../containers/FollowUp/FollowUpList/FollowUpNewCalls/FollowUpNewCalls";
import {BookNewFollowUp} from "../containers/FollowUp/BookNewFollowUp/BookNewFollowUp";
import {ClientDashboard} from "../containers/Dashboard/ClientDashboard/ClientDashboard";
import {OnBoardingComplete} from "../components/other/WelcomeData/OnboardincComplete/OnBoardingComplete";
import {SuggestionView} from "../containers/BusinessGoals/SuggestionView/SuggestionView";

const CLIENT:RouterType[] = [
  /*{
    exact: true,
    path: '/olddashboard',
    title: 'Клиент',
    Component: TasksKanban,
  },*/
  {
    exact: false,
    path: '/404',
    title: 'Legal Request',
    Component: NotFound,
  },
  {
    exact: true,
    path: '/tasks',
    title: 'Задачи по проектам',
    Component: TasksProjectKanban,
  },
  /*{
    exact: true,
    path: '/dataRoom',
    title: 'Клиент',
    Component: TasksKanban,
  },*/
  {
    exact: true,
    path: '/tasks/:id',
    title: 'Задача',
    Component: TaskView,
  },
  {
    exact: false,
    path: '/settings/',
    title: 'Настройки',
    Component: Settings,
  },
  {
    exact: false,
    path: '/onboarding',
    title: 'onBoarding',
    Component: OnBoarding,
  },
  {
    exact: false,
    path: '/offers',
    title: 'Настройки',
    Component: Offers,
  },
  {
    exact: false,
    path: '/onboarding-offer/:id',
    title: 'Offer',
    Component: Offer,
  },
  {
    exact: false,
    path: '/offer/:id',
    title: 'Offer',
    Component: Offer,
  },
  {
    exact: false,
    path: '/legal-request/:id',
    title: 'Legal Request',
    Component: LegalRequest,
  },
  {
    exact: false,
    path: '/test',
    title: 'Legal Request',
    Component: TestRoute,
  },
  {
    exact: false,
    path: '/test2',
    title: 'Legal Request',
    Component: Test,
  },
  {
    exact: false,
    path: '/checkout/:id',
    title: 'Legal Request',
    Component: Checkout,
  },
  {
    exact: false,
    path: '/deliverable-view/:id',
    title: 'Legal Request',
    Component: DeliverableView,
  },
  {
    exact: true,
    path: '/finish-bank-payment',
    title: 'finish-bank-payment',
    Component: FinishStep,
  },
  {
    exact: true,
    path: '/reports',
    title: 'reports',
    Component: Report,
  },
  {
    exact: true,
    path: '/document',
    title: 'Documents',
    Component: DocumentsList,
  },
  {
    exact: true,
    path: '/cors',
    title: 'Войти',
    Component: TestForCors,
  },
  {
    exact: false,
    path: '/search',
    title: 'Dashboard',
    Component: SearchResults,
  },
  {
    exact: false,
    path: '/legal-projects/:id',
    title: 'Dashboard',
    Component: BusinessGoalView,
  },
  {
    exact: false,
    path: '/legal-projects',
    title: 'Dashboard',
    Component: BusinessGoalsVloKanban,
  },
  {
    exact: false,
    path: '/payment-plan',
    title: 'Dashboard',
    Component: PaymentPlan,
  },
  {
    exact: false,
    path: '/update-nps/auth',
    title: 'Legal Request',
    Component: NpsNoAuthRoute,
  },
  {
    exact: false,
    path: '/update-nps/admin',
    title: 'Legal Request',
    Component: NpsAdmin,
  },
  {
    exact: false,
    path: '/update-nps',
    title: 'Legal Request',
    Component: UpdateNps,
  },
  {
    exact: false,
    path: '/follow-ups/:id',
    title: 'Legal Request',
    Component: FollowUpView,
  },
  {
    exact: false,
    path: '/follow-ups',
    title: 'Legal Request',
    Component: FollowUpList,
  },
  {
    exact: false,
    path: '/upcoming-calls',
    title: 'Legal Request',
    Component: FollowUpNewCalls,
  },
  {
    exact: false,
    path: '/book-new-calls',
    title: 'Legal Request',
    Component: BookNewFollowUp,
  },
  {
    exact: false,
    path: '/dashboard',
    title: 'Legal Request',
    Component: ClientDashboard,
  },
  {
    exact: false,
    path: '/o',
    title: 'Legal Request',
    Component: OnBoardingComplete,
  },
  {
    exact: false,
    path: '/projects/:id/suggestion/:suggestionId',
    title: 'Dashboard',
    Component: SuggestionView,
  },
]

export default CLIENT
